// Libs
import classNames from 'classnames/bind';
import { Avatar, AvatarGroup, Box, Tooltip, Zoom } from '@mui/material';
import { useTranslation } from 'react-i18next';
// Components, Layouts, Pages
// Others
import { IAvatarGroup } from '~/utils/interface/common';
import { EMPTY_STRING } from '~/utils/constants/common';
import { getInitials } from '~/utils/helper/common';
// Styles, images, icons
import styles from './BaseAvatarGroup.module.scss';

type Props = {
  avatars: IAvatarGroup[];
  max?: number;
  spacing?: 'small' | 'medium' | number;
  size?: number;
  borderColor?: string;
};

const cx = classNames.bind(styles);

const BaseAvatarGroup = (props: Props) => {
  //#region Destructuring Props
  const { avatars, max = 4, spacing = 'medium', size = 26, borderColor } = props;
  //#endregion Destructuring Props

  //#region Declare Hook
  const { t } = useTranslation(['common/base']);
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  //#endregion Declare State

  //#region Declare Memo
  //#endregion Declare Memo

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function
  //#endregion Handle Function

  return (
    <AvatarGroup
      component={'div'}
      className={cx('avatarGroup')}
      spacing={spacing}
      max={max}
      renderSurplus={(surplus) => (
        <Tooltip
          title={
            <Box>
              {avatars?.slice(max - 1)?.map((avatar, index) => (
                <Box key={index}>{avatar?.fullName || EMPTY_STRING}</Box>
              ))}
            </Box>
          }
          arrow
          placement='top'
          slots={{
            transition: Zoom,
          }}
        >
          <Avatar
            className={cx('surplus')}
            sx={{
              width: size,
              height: size,
              border: borderColor ? `2px solid ${borderColor} !important` : undefined,
            }}
          >
            {`+${surplus}`}
          </Avatar>
        </Tooltip>
      )}
      slotProps={{
        surplus: {
          sx: {
            width: size,
            height: size,
            border: borderColor ? `2px solid ${borderColor} !important` : undefined,
          },
        },
      }}
    >
      {avatars?.map((avatar, index) => (
        <Tooltip
          key={index}
          title={avatar?.fullName || EMPTY_STRING}
          arrow
          placement='top'
          slots={{
            transition: Zoom,
          }}
        >
          <Avatar
            alt={t('common_alt_img')}
            src={avatar?.avatarUrl}
            sx={{
              width: size,
              height: size,
              border: borderColor ? `2px solid ${borderColor} !important` : undefined,
            }}
            className={cx('avatar')}
          >
            {getInitials(avatar?.fullName || EMPTY_STRING)}
          </Avatar>
        </Tooltip>
      ))}
    </AvatarGroup>
  );
};

export default BaseAvatarGroup;
